<template>
	<AppMainSearchCard
		:tituloTela="$t('feeding.title')"
		:isLoading="feedingListRequestStatus.loading"
		@add="$router.push({ name: 'feedingFormNew' })"
	>
		<v-layout wrap row justify-center>
			<v-flex class="item" xs11 md11 lg11 pb-2>
				<search-input :on-search="onQueryChanged" label="feeding.search-placeholder" />
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-center pa-3>
			<v-flex class="item" sm11 xs11 md12 lg12>
				<v-data-table
					:headers="headers"
					@click:row="editItem"
					:no-results-text="$t('feeding.empty-list-message')"
					:loading="feedingListRequestStatus.loading"
					:must-sort="true"
					:items="feedingListRequestStatus.data.data"
					color="secondary"
					:loading-text="$t('common.loading-list-message')"
					:options.sync="listData.pagination"
					:server-items-length="feedingListRequestStatus.data.meta.total_itens"
					@update:options="fetchItems"
					:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
					:items-per-page="listData.pagination.itemsPerPage"
				>
					<template
						v-slot:item.explorationUnitType="{ item }"
					>{{$t((item.explorationUnitType && item.explorationUnitType.title) || 'common.not-defined')}}</template>
					<template
						v-slot:item.genderType="{ item }"
					>{{$t((item.genderType && item.genderType.title) || 'common.not-defined')}}</template>
					<template v-slot:item.actions="{ item }">
						<record-action-column
							:on-delete-confirmation="() => deleteItem(item)"
							:delete-message="$t('feeding.delete-record-text', { name: item.nmArracoamento })"
						/>
					</template>
				</v-data-table>
			</v-flex>
			<v-snackbar v-model="snackbar.visible" :color="snackbar.color">{{ snackbar.message }}</v-snackbar>
		</v-layout>
	</AppMainSearchCard>
</template>

<script>
import { mapState } from 'vuex';
import { RequestStatusKeys } from '@/modules/common';
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue';
import { SearchInput, RecordActionColumn } from '@/components';

export default {
	name: 'FeedingList',
	components: {
		AppMainSearchCard,
		SearchInput,
		RecordActionColumn,
	},
	data() {
		return {
			listRequestKey: RequestStatusKeys.FEEDING_LIST.key,
			listData: {
				query: '',
				pagination: {
					itemsPerPage: 15,
				},
			},
			snackbar: {
				visible: false,
				message: null,
			},
			headers: [
				{ text: this.$t('common.name'), value: 'nmArracoamento' },
				{
					text: this.$t('common.exploration-unit-type'),
					value: 'explorationUnitType',
				},
				{ text: this.$t('common.animal-gender'), value: 'genderType' },
				{
					text: this.$t('common.actions'),
					value: 'actions',
					sortable: false,
					width: '75px',
				},
			],
		};
	},
	computed: {
		...mapState({
			feedingListRequestStatus: (state) =>
				state.requestStatus[RequestStatusKeys.FEEDING_LIST.key],
			feedingDeletionRequestStatus: (state) =>
				state.requestStatus[RequestStatusKeys.FEEDING_DELETION.key],
		}),
	},
	methods: {
		editItem(feedingItem) {
			const route = {
				name: 'feedingFormEdit',
				params: { id: feedingItem.idArracoamento },
			};
			this.$router.push(route);
		},
		async deleteItem(feedingItem) {
			const data = { id: feedingItem.idArracoamento };
			await this.$store.dispatch('DeleteFeedingItemAction', data);

			if (this.feedingDeletionRequestStatus.error) {
				this.showSnackbar('common.error-remove-record', 'error');
			} else {
				this.reloadList();
				this.showSnackbar('common.successfully-removed-record');
			}
		},
		reloadList() {
			if (
				this.feedingListRequestStatus.data.data.length == 1 &&
				this.listData.pagination.page > 1
			) {
				this.listData.pagination.page--;
			} else {
				this.fetchItems();
			}
		},
		onQueryChanged({ query }) {
			if (this.listData.query === query) {
				return;
			}

			this.listData.query = query;
			// When we change the page, the fetchItems method is automatically triggered.
			if (this.listData.pagination.page === 1) {
				this.fetchItems();
			} else {
				this.listData.pagination.page = 1;
			}
		},
		fetchItems() {
			const params = {
				page: this.listData.pagination.page,
				per_page: this.listData.pagination.itemsPerPage,
			};

			if (this.listData.query) {
				params.nmArracoamento = this.listData.query;
			}

			if (this.listData.pagination.sortDesc.requestKeylength) {
				let orderField = this.listData.pagination.sortBy[0];
				if (orderField === 'explorationUnitType') {
					orderField = 'sgTipoUep';
				} else if (orderField === 'explorationUnitType') {
					orderField = 'sgSexo';
				}

				params.order = {
					field: orderField,
					desc: this.listData.pagination.sortDesc[0],
				};
			}

			this.$store.dispatch('GetFeedingListAction', params);
		},
		showSnackbar(message, color = 'success') {
			this.snackbar.color = color;
			this.snackbar.message = this.$t(message);
			this.snackbar.visible = true;
		},
	},
};
</script>

<style>
.v-data-table tr.v-data-table__mobile-table-row {
	box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
		0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
	display: block;
	margin: 15px 1px;
}
</style>